import type { LucideIcon } from "lucide-react";
import {
    CreditCard,
    Gift,
    Home,
    LogOut,
    MapPin,
    Package,
    ReceiptText,
    ShoppingBasket,
    TicketPercent,
    UserRound,
} from "lucide-react";

export type UserNavGroup =
    | "Inicio"
    | "Suscripción"
    | "Compras"
    | "Cuenta"
    | "Promociones"
    | "Sesión";

export type UserNavItem = {
    title: string;
    href: string;
    icon: LucideIcon;
    group: UserNavGroup;
    mobilePrimary?: boolean;
};

export const userNavItems: UserNavItem[] = [
    {
        title: "Inicio",
        href: "/user/home",
        icon: Home,
        group: "Inicio",
        mobilePrimary: true,
    },
    {
        title: "Tienda",
        href: "/user/store",
        icon: ShoppingBasket,
        group: "Compras",
        mobilePrimary: true,
    },
    {
        title: "Suscripción",
        href: "/user/subscription",
        icon: Package,
        group: "Suscripción",
        mobilePrimary: true,
    },
    {
        title: "Pedidos",
        href: "/user/orders",
        icon: ReceiptText,
        group: "Compras",
        mobilePrimary: true,
    },
    {
        title: "Personaliza tu caja",
        href: "/user/subscription/box",
        icon: Package,
        group: "Suscripción",
    },
    {
        title: "Editar suscripción",
        href: "/user/subscription/edit",
        icon: Package,
        group: "Suscripción",
    },
    {
        title: "Métodos de pago",
        href: "/user/payment-methods",
        icon: CreditCard,
        group: "Cuenta",
    },
    {
        title: "Perfil",
        href: "/user/account",
        icon: UserRound,
        group: "Cuenta",
    },
    {
        title: "Direcciones",
        href: "/user/shipping/edit",
        icon: MapPin,
        group: "Cuenta",
    },
    {
        title: "Cupones",
        href: "/user/discounts",
        icon: TicketPercent,
        group: "Promociones",
    },
    {
        title: "Invita y gana",
        href: "/user/referral",
        icon: Gift,
        group: "Promociones",
    },
    {
        title: "Cerrar sesión",
        href: "/logout",
        icon: LogOut,
        group: "Sesión",
    },
];

export const primaryMobileNavItems = userNavItems.filter(
    (item) => item.mobilePrimary,
);

export const secondaryMobileNavItems = userNavItems.filter(
    (item) => !item.mobilePrimary,
);

export const getActiveUserNavHref = (pathname: string) => {
    const matchedItem = userNavItems
        .filter(
            (item) =>
                pathname === item.href || pathname.startsWith(`${item.href}/`),
        )
        .sort((a, b) => b.href.length - a.href.length)[0];

    return matchedItem?.href;
};

export const navGroups = [
    "Inicio",
    "Suscripción",
    "Compras",
    "Cuenta",
    "Promociones",
    "Sesión",
] as const satisfies readonly UserNavGroup[];
